module.exports = __webpack_public_path__ + "static/media/circle-line.94dfb5e8.svg";